import React, { useState, useEffect } from "react";
import "./FAQ.css";
import { useApp } from "../../AppContext/AppContext";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { currentColor } = useApp();
  const [showUpArrow, setShowUpArrow] = useState(false);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleScroll = () => {
    const heroElement = document.getElementById('home');
    if (heroElement) {
      const heroBottom = heroElement.getBoundingClientRect().bottom;
      setShowUpArrow(heroBottom < window.innerHeight && window.scrollY > 0);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const faqData = [
    {
      question: "How to use the Download button?",
      answer: 'If you want to download any videos online, you need to copy the link of the post and paste it on the main page of our website. Then click the "Download" button. Everything is very simple!'
    },
    {
      question: "How to download a video from all social media platforms on mobile phone?",
      answer: "Download our mobile app from the app store, copy the video link from any social media platform and paste it into the app. Click download to save the video."
    },
    {
      question: "Is the All Video Downloader app free?",
      answer: "Yes, the basic version of our video downloader is completely free to use. Premium features are available with a subscription."
    },
    {
      question: "What browsers can I use with All Video Downloader?",
      answer: "Our downloader works with all major browsers including Chrome, Firefox, Safari, Edge, and Opera."
    },
    {
      question: "Why does the video play instead of downloading?",
      answer: "This usually happens if your browser's download settings need adjustment. Make sure downloads aren't blocked and try clearing your browser cache."
    },
    {
      question: "What video quality does All Video Downloader support?",
      answer: "We support downloads in multiple qualities from 360p up to 4K, depending on the original video quality available."
    },
  ];

  return (
    <section className="faq-section" aria-labelledby="faq-title">
      <div className="faq-container">
        <div className="faq-content">
          <div className="faq-image">
            <img src="/assets/faq.svg" alt="" aria-hidden="true" />
          </div>

          <div className="faq-text">
            <h2 id="faq-title" className="faq-heading">
              Frequently asked <span style={{ color: currentColor }}>Questions</span>
            </h2>
            <p className="faq-subtitle">
              Got Questions? We've Got Answers — Explore Our FAQs
            </p>

            <div className="faq-list" role="list">
              {faqData.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-item ${openIndex === index ? "active" : ""}`}
                  role="listitem"
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={openIndex === index}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <span>{faq.question}</span>
                    <img className="faq-icon"
                      src={`/assets/${
                        openIndex === index ? "dropUp" : "dropDown"
                      }.svg`}
                    />
                  </button>

                  <div
                    id={`faq-answer-${index}`}
                    className="faq-answer"
                    role="region"
                    aria-hidden={openIndex !== index}
                  >
                    {faq.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {showUpArrow && (
          <div className="faq-up-arrow" onClick={scrollToTop}>
            <img src="/assets/Up-Arrow-Btn.png" alt="Scroll to top" className="fixed-image" />
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQ;
